import { Grid, LinearProgress, ListItem, ListItemIcon, ListItemText } from '@mui/material';

import StepNotStarted from 'assets/icons/StepNotStarted.svg?react';
import StepInProgress from 'assets/icons/StepInProgress.svg?react';
import StepCompleted from 'components/AgGrid/assets/task-configuration-icons/approve-icon.svg?react';
import { jbColors } from 'theme/jbColors';
import { ServiceAgreementV2MacroStepListInner } from 'pco-product-service-internal-consumer';

type MacroStepStatus = 'yetToStart' | 'inProgress' | 'completed' | string;

const renderStatusStepSVG = (status: MacroStepStatus | undefined) => {
  if (status === 'yetToStart') {
    return <StepNotStarted />;
  } else if (status === 'inProgress') {
    return <StepInProgress />;
  } else if (status === 'completed') {
    return <StepCompleted />;
  }
  return null;
};

const calculateProgressBarPercentage = (status: MacroStepStatus | undefined) => {
  if (status === 'yetToStart') {
    return 0;
  } else if (status === 'inProgress') {
    return 50;
  } else if (status === 'completed') {
    return 100;
  }
  return 0;
};

const calculateColour = (status: MacroStepStatus | undefined) => {
  if (status === 'yetToStart') {
    return jbColors.support.greenSmoke[100];
  } else if (status === 'inProgress') {
    return jbColors.support.alertBlue[110];
  } else if (status === 'completed') {
    return jbColors.core.green[100];
  }
};

const StatusBar = ({ macroStepList }: { macroStepList?: ServiceAgreementV2MacroStepListInner[] }) => {
  return (
    <Grid container spacing={0.5} xl={12} data-testid={'activation-status-container'}>
      {macroStepList?.map((step: ServiceAgreementV2MacroStepListInner, index: number) => (
        <Grid item key={index}>
          <Grid container>
            <Grid item>
              <LinearProgress
                variant="determinate"
                value={calculateProgressBarPercentage(step.status)}
                sx={[
                  {
                    height: '2px',
                    backgroundColor: jbColors.support.solidGrayIcon[10],
                    '& .MuiLinearProgress-bar1Determinate': {
                      backgroundColor: calculateColour(step.status),
                    },
                  },
                ]}
              />
              <ListItem key={index} sx={{ paddingLeft: 0 }}>
                <ListItemIcon> {renderStatusStepSVG(step.status)} </ListItemIcon>
                <ListItemText
                  sx={{
                    position: 'relative',
                    right: '2rem',
                    '& .MuiListItemText-primary': {
                      color: calculateColour(step.status),
                    },
                  }}
                  primary={step.step}
                />
              </ListItem>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatusBar;
